import { Link } from "react-router-dom";
import Login from "../Page/Login";
import { callAPIWithoutAuth } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";
import { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../languages";

function Footer() {
  const [data, setData] = useState([]);
  const { language } = useLanguage();
  const t = translations[language];

  const Getcontentlisting = async () => {
    try {
      const apiResponse = await callAPIWithoutAuth(
        apiUrls.contentlisting,
        {},
        "GET",
        {},
      );
      if (apiResponse?.data?.success) {
        setData(apiResponse?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    Getcontentlisting();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="footer-contact">
        <div className="container">
          <div className="d-flex flex-wrap justify-content-lg-between justify-content-center align-items-center text-center">
            <h3 class="mb-lg-0 mb-3 fw-semibold fs-4">
              {t.FooterContact.heading}
            </h3>
            <div className="d-flex align-items-center gap-2 footer-contact-btns-sec">
              <Link to="/restaurant" className="btn primary-btn ">
                {t.FooterContact.restaurantButton}
              </Link>
              <Link to="/food-truck" className="btn white-btn ">
                {t.FooterContact.foodTruckButton}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="footer-content">
                <div className="flogo mb-lg-4 mb-3">
                  <img src="/image/footer-logo.png" alt="" />
                </div>
                <div className="footer-inner-content mb-40">
                  <p className="mb-0">{t.FooterContact.description}</p>
                </div>
                <div className="social-sec">
                  <h5> {t.FooterContact.socialHeading}</h5>
                  <div className="footer-icons d-flex gap-2 mt-4">
                    <Link
                      to="https://www.instagram.com/alis_kebab/?utm_source=ig_embed&ig_rid=975da240-09c3-4413-8e85-6478b9dd8bb6"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/image/instagram.svg" alt="" />
                    </Link>
                    <Link
                      to="https://www.facebook.com/aliskebabjp?fref=nf&ref=embed_page"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/image/facebook-f.svg" alt="" />
                    </Link>
                     <Link
                      to="https://lin.ee/QcSLvNv"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/image/line1.svg" alt="" />
                    </Link>
                    <a href="mailto:ali@alisgroup.co.jp">
                      <img src="/image/emailsvg.svg" alt="Email" />
                    </a>
                    {/* <Link to="#">
                      <img src="/image/twitter.svg" alt="" />
                    </Link>
                    <Link to="#">
                      <img src="/image/linkedin.svg" alt="" />
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="shot_menu ps-md-5">
                <h5> {t.FooterContact.quickLinksHeading}</h5>
                <div className="short_menu_options d-flex">
                  <ul>
                    <li>
                      <Link to="/">
                        <img src="/image/angle-right.svg" alt="" /> {t.home}
                      </Link>
                    </li>
                    <li>
                      <Link to="/about">
                        <img src="/image/angle-right.svg" alt="" /> {t.about}
                      </Link>
                    </li>
                    <li>
                      <Link to="/menu?type=Regular">
                        <img src="/image/angle-right.svg" alt="" /> {t.menu}
                      </Link>
                    </li>
                    <li>
                      <Link to="/menu?type=Bento">
                        <img src="/image/angle-right.svg" alt="" /> {t.Bento}
                      </Link>
                    </li>
                    <li>
                      <Link to="/food-truck">
                        <img src="/image/angle-right.svg" alt="" />{" "}
                        {t.foodTruck}
                      </Link>
                    </li>
                    <li>
                      <Link to="/restaurant">
                        <img src="/image/angle-right.svg" alt="" />{" "}
                        {t.restaurant}
                      </Link>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <Link to="/contact">
                        <img src="/image/angle-right.svg" alt="" /> {t.contact}
                      </Link>
                    </li>
                    <li>
                      <Link to="/delivery">
                        <img src="/image/angle-right.svg" alt="" /> {t.Delivery}
                      </Link>
                    </li>
                    <li>
                      <Link to="/catering">
                        <img src="/image/angle-right.svg" alt="" /> {t.Catering}
                      </Link>
                    </li>

                    {data?.map((item, index) => {
                      return (
                        <li key={index}>
                          <Link to={`/content/${item?.id}`}>
                            <img src="/image/angle-right.svg" alt="" />{" "}
                            {language === "en"
                              ? item?.en_title
                              : item?.ja_title}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="support">
                <Link to="#">
                  <span className="d-block">{t.FooterContact.liveSupport}</span>{" "}
                  ali@alisgroup.co.jp
                </Link>
              </div>
              {/* <div className="subscribe">
                <label>{t.FooterContact.newsletterLabel}</label>
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t.FooterContact.newsletterPlaceholder}
                  />
                  <button type="button">{t.FooterContact.subscribeButton}</button>
                </div>
              </div> */}
              <div className="subscribe">
                <label> {t.ContactUsContent.Getintouch}</label>
                <div className="contact-list grey">
                  <div className="contact-icon">
                    <img src="/image/address.svg" alt="" />
                  </div>
                  <div className="contact-list-content">
                    <span className="contact-list-title">
                      {" "}
                      {t.ContactUsContent.addressLabel}
                    </span>
                    <p className="contact-list-desc mb-0">
                      {t.ContactUsContent.address}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="copy-right d-md-flex align-md-items-center justify-content-between">
            <p>{t.FooterContact.copyright}</p>
            <p>
              {t.FooterContact.poweredBy}{" "}
              <Link
                to="https://www.braintechnosys.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Brain Technosys
              </Link>
            </p>
          </div>
        </div>
        <div className="whatsapp-chat-button">
  <Link to="https://wa.me/819085622102" target="_blank" rel="noopener noreferrer">
    <img src="/image/whatsappicon.webp" alt="WhatsApp" />
  </Link>
</div>
      </footer>

      <Login />
    </>
  );
}

export default Footer;
